import { Outlet } from "react-router-dom";
import PlanHeader from "../components/PlanHeader";
import { DrawerProvider } from "../../../shared/providers/DrawerProvider";
import Drawer from "../../../shared/components/Drawer";

export default function PlanLayout() {
  return (
    <DrawerProvider>
      <div className="text-white flex flex-col w-full">
        <PlanHeader />
        <div className="pt-15 flex items-center justify-center">
          <Outlet />
        </div>
      </div>
      <Drawer />
    </DrawerProvider>
  );
}
